module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-202.979a2f28.svg";